import { RedirectToSignIn, useAuth, useUser } from "@clerk/clerk-react";
import { Navigate, Outlet } from "react-router-dom";
import { PageSkeleton } from "./PageSkeleton";

export function RequireAuth() {
	const { isSignedIn, isLoaded } = useAuth();
	if (!isLoaded) return <PageSkeleton />;
	if (!isSignedIn) return <RedirectToSignIn />;
	return <Outlet />;
}

export function RequireAdmin() {
	const { user } = useUser();
	if (user?.publicMetadata?.role !== "admin") {
		return <Navigate to="/403" replace />;
	}
	return <Outlet />;
}
